import React from "react"
import { ReactMarkdownProps } from "react-markdown"
import { StyledMarkdown } from "./style"

const Markdown = (props: ReactMarkdownProps) => {
  return <StyledMarkdown {...props} />
}

export default Markdown
